import React from 'react';
import { Tabs, message } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, GetMetaProperties, SetMetaProperties, Model, POST, QueryDetail, QueryOrder, errorCatch, getObjectDisplay, updateInPropertiesUUID, updateInArray, useAuth, useMetaContext, deleteInProperties, contextFilterToObject, foreachInProperties, useClipboardContext, clean } from 'fennec-ui'
import PageLayout from '../../components/PageLayout';
import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import { goTo } from '../../../common/Tool';
import User from '../../../common/User';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';

var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function FederationadministratorSettingsAttestation(props) {
    const auth = useAuth()
    const meta = useMetaContext()

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }
        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        if(obj.name === "ParametriProtokolovTesta"){
            p = deleteInProperties(p, ["DopustimoeKolvoOshibok"])
        }
        
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.type == "object"), {
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta, contextObject) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]

                return [{
                    title: "Создать",
                    form: Model,

                    object: {},

                    // links: true,
                    // links: "inline",
                    // modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },
                    // collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },

                    meta: cleanProperties(m, {...context, contextObject: contextObject}),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
                ]
            }
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "User"), {
            mode: "dialog",
            relation: {
                uiFilter: () => [
                    {
                        name: "lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.lastname + " " + item?.firstname
                },
                display: (item) => {
                    return (
                        <User item={item} />
                    )
                },
                reference: { object: "User", property: "ID" },
                type: "many-one",
            },
            dropdownActions: undefined,
            queryFilter: [
                QueryDetail("combobox"),
                QueryOrder("firstname", "ASC")
            ]
        })

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        p = foreachInProperties(p, n => (obj.name === "NastroikiOtsenokProtokolovTesta" && n.name === "ParametrKriteriya"), {
            source: `/api/testisudeiskikhattestatsii/criterion-params-by-tantsor/${contextObject?.ID}`,
            dropdownActions: undefined
        })

        return SetMetaProperties(obj, p)
    }

    const [clipboard, setClipboard] = useClipboardContext()
    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <Tabs defaultActiveKey="system-attestation">
                    <TabPane key="system-kategorii-voprosov" tab={"Категории вопросов"}>
                        <CollectionServer
                            auth={auth}
                            name={"KategoriiVoprosov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("KategoriiVoprosov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "KategoriiVoprosov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}


                            linksModelActions={"inline"}
                            // linksModelActions={true}
                            // linksCompareFunction={(obj)=>{
                            //     return _.get(obj, "relation.reference.object")
                            //     //return _.get(obj, "name")
                            // }}
                            // scheme={[
                            //     "VoprosiSudeiskikhAttestatsii.VariantiOtvetov",
                            //     "VoprosiSudeiskikhAttestatsii.ParametriVoprosa",
                            //     "ParametriShablonovTestov",
                            // ]}
                            scheme={[
                                "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa.VariantiOtvetovVopros",
                                "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa.ParametriVoprosaVopros",
                                "ParametriShablonovTestovKategoriyaVoprosa"
                            ]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (fieldName === "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa") {
                                    let funcs = [
                                        (p) => deleteInProperties(p, "MultiSelect")
                                    ];
                                    let _act = actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}, funcs) }));
                                    let _link = {
                                        auth: auth,
                                        title: "Просмотр",
                                        action: (values, unlock, close) => {
                                            goTo(`/app/reports/voprosisudeiskikhattestatsii/${item?.ID}`)
                                        }
                                    }
                                    return [_link, { type: 'divider', }, ..._act]
                                }
                                if (name === "KategoriiVoprosov") {
                                    let _act = actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }));
                                    let _link = {
                                        auth: auth,
                                        title: "Просмотр",
                                        action: (values, unlock, close) => {
                                            goTo(`/app/reports/kategoriivoprosov/${item?.ID}`)
                                        }
                                    }
                                    return [_link, { type: 'divider', }, ..._act]
                                }
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []
                                if (fieldName === "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa") {
                                    funcs.push((p) => deleteInProperties(p, "MultiSelect"));
                                }
                                let ac = actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                    <TabPane key="system-shabloni-testov" tab={"Шаблоны тестов"}>
                        <CollectionServer
                            auth={auth}
                            name={"ShabloniTestov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("ShabloniTestov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "ShabloniTestov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={"inline"}

                            scheme={[
                                "AktivnieShabloniShablon",
                                "ParametriShablonovTestovShablon",
                                "ParametriProtokolovTestaShablonTesta.TantsoriProtokolaTestaParametriProtokolaTesta.NastroikiMestTantsorovProtokolaTestaUchastnik",
                                "ParametriProtokolovTestaShablonTesta.TantsoriProtokolaTestaParametriProtokolaTesta.NastroikiOtsenokProtokolovTestaUchastnik"
                            ]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                    <TabPane key="system-aktivnie-shabloni" tab={"Активные шаблоны"}>
                        <CollectionServer
                            auth={auth}
                            name={"AktivnieShabloni"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("AktivnieShabloni")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "AktivnieShabloni", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                    <TabPane key="system-kategorii-sudei" tab={"Категории судей"}>
                        <CollectionServer
                            auth={auth}
                            name={"KategoriiSudei"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("KategoriiSudei")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "KategoriiSudei", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                    <TabPane key="system-kategorii-konkretnogo-sudi" tab={"Категории судьи"}>
                        <CollectionServer
                            auth={auth}
                            name={"KategoriiKonkretnogoSudi"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("KategoriiKonkretnogoSudi")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "KategoriiKonkretnogoSudi", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject, object: item}) }))
                                // return actions
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                                // return actions
                            }}
                        />
                    </TabPane>
                    {/* <TabPane key="system-parametri-shablonov-testov" tab={"Параметры шаблонов тестов"}>
                        <CollectionServer
                            auth={auth}
                            name={"ParametriShablonovTestov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("ParametriShablonovTestov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "ParametriShablonovTestov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane> */}
                    {/* <TabPane key="system-parametri-voprosa" tab={"Параметры вопроса"}>
                        <CollectionServer
                            auth={auth}
                            name={"ParametriVoprosa"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("ParametriVoprosa")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "ParametriVoprosa", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane> */}
                    {/* <TabPane key="system-testi-sudeiskikh-attestatsii" tab={"Тесты судейских аттестаций"}>
                        <CollectionServer
                            auth={auth}
                            name={"TestiSudeiskikhAttestatsii"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("TestiSudeiskikhAttestatsii")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TestiSudeiskikhAttestatsii", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane> */}
                    {/* <TabPane key="system-varianti-otvetov" tab={"Варианты ответов"}>
                        <CollectionServer
                            auth={auth}
                            name={"VariantiOtvetov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("VariantiOtvetov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "VariantiOtvetov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane>
                    <TabPane key="system-voprosi-sudeiskikh-attestatsii" tab={"Вопросы судейских аттестаций"}>
                        <CollectionServer
                            auth={auth}
                            name={"VoprosiSudeiskikhAttestatsii"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("VoprosiSudeiskikhAttestatsii")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "VoprosiSudeiskikhAttestatsii", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane> */}
                    {/* <TabPane key="system-faili-otvetov" tab={"Файлы ответов"}>
                        <CollectionServer
                            auth={auth}
                            name={"FailiOtvetov"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("FailiOtvetov")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FailiOtvetov", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane>
                    <TabPane key="system-faili-voprosa" tab={"Файлы вопросов"}>
                        <CollectionServer
                            auth={auth}
                            name={"FailiVoprosa"}
                            queryDetail={"collection"}
                            filters={() => filtersFromMeta("FailiVoprosa")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "FailiVoprosa", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={true}

                            defaultModelActions={true}
                            defaultModelActionMeta={(mobject, item) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                            defaultCollectionActions={true}
                            defaultCollectionActionMeta={(mobject) => cleanProperties(mobject, {name, field, fieldName, contextObject})}
                        />
                    </TabPane> */}

                </Tabs>
            </div>
        </PageLayout >
    );
}